<template>
  <div>
    <div class="header">
      <div class="nav-container">
        <div class="logo" @click="$route.path !== '/' && $router.push('/')">
          <img src="@/assets/logo.png" alt="" class="logo" />
        </div>
<!--        <div>
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <template  v-for="item in categorys"   >
              <el-menu-item :key="item.cate_id" v-if="!item.children.length" :index="item.cate_id + ''">{{ item.name }}</el-menu-item>
              <el-submenu :key="item.cate_id" v-else :index="item.cate_id + ''">
                <template slot="title">{{ item.name }}</template>
                <el-menu-item v-for="itm in item.children" :key="itm.cate_id" :index="itm.cate_id + ''">{{ itm.name }}</el-menu-item>
              </el-submenu>
            </template>
            </el-menu>
        </div>-->
        <div class="auth-buttons">
          <!-- 已登录 -->
          <el-button v-if="isLoggedIn" class="login-btn" @click="$route.path !== '/profile' && $router.push('/profile')">
            <el-image width="100px" height="100px" :src="userInfo.avatar || ''"></el-image>
          </el-button>
          <!-- 未登录 -->
          <el-button v-else class="login-btn" @click="handleLogin">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" color="currentColor" class="" stroke-width="1.5" stroke="currentColor">
              <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="1.5"></path>
              <path d="M14.75 9.5C14.75 11.0188 13.5188 12.25 12 12.25C10.4812 12.25 9.25 11.0188 9.25 9.5C9.25 7.98122 10.4812 6.75 12 6.75C13.5188 6.75 14.75 7.98122 14.75 9.5Z" stroke="currentColor" stroke-width="1.5"></path>
              <path d="M5.49994 19.0001L6.06034 18.0194C6.95055 16.4616 8.60727 15.5001 10.4016 15.5001H13.5983C15.3926 15.5001 17.0493 16.4616 17.9395 18.0194L18.4999 19.0001" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
            </svg>
          </el-button>
        </div>
      </div>
    </div>

    <!-- Caixa de diálogo de login -->
    <el-dialog append-to-body
      :title="showType"
      :visible.sync="loginDialogVisible"
      width="400px" class="login-dialog"
      :close-on-click-modal="false"
    >
      <el-form v-show="showType === 'Login'" :model="loginForm" :rules="loginRules" ref="loginForm" label-width="80px" label-position="top">
        <el-form-item label="Email" prop="email">
          <el-input
            v-model="loginForm.email"
            placeholder="Por favor, insira o email"
            type="email"
          ></el-input>
        </el-form-item>
        <el-form-item label="Senha" prop="password">
          <el-input
            v-model="loginForm.password"
            placeholder="Por favor, insira a senha"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form v-show="showType === 'Register'" :model="registerForm" :rules="registerRules" ref="registerForm" label-width="80px" label-position="top">
        <el-form-item label="Email" prop="email">
          <el-input
            v-model="registerForm.email"
            placeholder="Por favor, insira o email"
            type="email"
          ></el-input>
        </el-form-item>
        <el-form-item label="Senha" prop="password">
          <el-input
            v-model="registerForm.password"
            placeholder="Por favor, insira a senha"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="Whatsapp" prop="mobile">
          <el-input
            v-model="registerForm.mobile"
            placeholder="Por favor, insira o whatsapp"
          ></el-input>
        </el-form-item>
        <el-form-item label="Nome da Empresa" prop="company_name">
          <el-input
            v-model="registerForm.company_name"
            placeholder="Por favor, insira o nome da empresa"
          ></el-input>
        </el-form-item>
        <el-form-item label="Endereço" prop="address">
          <el-input
            v-model="registerForm.address"
            placeholder="Por favor, insira o endereço"
          ></el-input>
        </el-form-item>
        <el-form-item label="CNPJ/CPF" prop="tax_number">
          <el-input
            v-model="registerForm.tax_number"
            placeholder="Por favor, insira o CNPJ/CPF"
          ></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="submitLogin" :loading="loginLoading" style="width: 100%">Enviar</el-button>
      </div>
      <div style="margin-top:20px;">
        <div v-if="showType === 'Login'">Ainda não tem uma conta?<span style="color: #eb3342; cursor: pointer;margin-left:5px;" @click="handleSwitchType('Register')">Criar conta</span></div>
        <div v-if="showType === 'Register'">Já tem uma conta?<span style="color: #eb3342; cursor: pointer;margin-left:5px;" @click="handleSwitchType('Login')">Ir para login</span></div>
      </div>
    </el-dialog>

    <div class="floating-whatsapp" @click="openWhatsapp">
      <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { categoryList, doRegister, getConfig } from '@/api/home'


export default {
  name: 'NavbarComponent',
  data() {
    return {
      showType:'Login',
      activeIndex: null,
      categorys: [],
      config: {},
      loginDialogVisible: false, // 登录弹窗显示状态
      loginLoading: false, // 登录按钮加载状态
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        email: '',
        password: '',
        mobile: '',
        company_name: '',
        address: '',
        tax_number: ''
      },
      loginRules: {
        email: [
          { required: true, message: 'Por favor, insira o email', trigger: 'blur' },
          { type: 'email', message: 'Por favor, insira um formato de email válido', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Por favor, insira a senha', trigger: 'blur' },
          { min: 6, message: 'A senha não pode ter menos de 6 caracteres', trigger: 'blur' }
        ]
      },
      registerRules: {
        email: [
          { required: true, message: 'Por favor, insira o email', trigger: 'blur' },
          { type: 'email', message: 'Por favor, insira um formato de email válido', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Por favor, insira a senha', trigger: 'blur' },
          { min: 6, message: 'A senha não pode ter menos de 6 caracteres', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: 'Por favor, insira o celular', trigger: 'blur' }
        ],
        company_name: [
          { required: true, message: 'Por favor, insira o nome da empresa', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Por favor, insira o endereço', trigger: 'blur' }
        ],
        tax_number: [
          { required: true, message: 'Por favor, insira o CNPJ/CPF', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'userInfo'])
  },
  mounted() {
    // this.getAllCategorys()

    // 如果已登录，获取用户信息
    if (this.isLoggedIn) {
      this.getUserInfo().then(res=>{

      }).catch(err=>{

      })
    }
      // 监听全局登录弹窗事件
    this.$root.$on('showLoginDialog', () => {
      this.loginDialogVisible = true
    })
    this.getConfigInfo()
  },
   beforeDestroy() {
    // 移除事件监听
    this.$root.$off('showLoginDialog')
  },

  methods: {
    ...mapActions('user', ['login', 'getUserInfo']),
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      if (keyPath.length === 1) {
        this.$router.push({
          path: '/category',
          query: {
            cate_id: key
          }
        })
      }
    },

    getAllCategorys() {
      categoryList().then(res => {
        console.log('categoryList', res)
        this.categorys = res.data
      })
    },

    getConfigInfo(){
      getConfig().then(res=>{
        this.config = res.data
      }).catch(err=>{
        console.log('err',err)
      })
    },

    openWhatsapp(){
      let whatsapp = this.config.whatsapp
      if(whatsapp){
        window.open('https://api.whatsapp.com/send/?phone=' + whatsapp)
      }else{
        this.$message.warning('客服电话未配置')
      }
    },

    // 处理登录按钮点击
    handleLogin() {
      this.loginDialogVisible = true
    },

    // 切换登录/注册类型
    handleSwitchType(type) {
      if (type === 'Register') {
        this.loginForm.email = ''
        this.loginForm.password = ''
      } else {
        this.registerForm.email = ''
        this.registerForm.password = ''
        this.registerForm.mobile = ''
        this.registerForm.company_name = ''
        this.registerForm.address = ''
        this.registerForm.tax_number = ''
      }
      this.$nextTick(() => {
        this.showType = type
      })
    },

    // 提交登录
    async submitLogin() {
      if (this.showType === 'Login') {
        this.$refs.loginForm.validate(async (valid) => {
          if (valid) {
            this.loginLoading = true
            try {
              await this.login(this.loginForm)
              this.loginDialogVisible = false
              this.$message.success('Login realizado com sucesso!')
              this.resetLoginForm()
              this.getUserInfo()
            } catch (error) {
              console.log('err', error.message)
            } finally {
              this.loginLoading = false
            }
          }
        })
      } else {
        this.$refs.registerForm.validate(async (valid) => {
          if (valid) {
            this.loginLoading = true
            try {
              await doRegister(this.registerForm)
              this.$message.success('Registro realizado com sucesso!')
              this.showType = 'Login'
            } catch (error) {
              console.log('err', error.message)
            } finally {
              this.loginLoading = false
            }
          }
        })
      }
    },

    // 重置登录表单
    resetLoginForm() {
      this.loginForm = {
        email: '',
        password: ''
      }
      this.$refs.loginForm && this.$refs.loginForm.resetFields()
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 80px;
  background: #fff;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.03);
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  cursor: pointer;
  height: 50px;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.auth-buttons {
  display: flex;
  gap: 10px;
}

.login-btn {
  width: 50px;
  height: 50px;
  color: #111;
  background: #fff;
  border: none;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  overflow: hidden;
}

.login-btn:hover {
  background: #f3f4f6;
  border-color: #f3f4f6;
  color: #111;
}
.login-btn:focus {
  background: #f3f4f6;
  border-color: #f3f4f6;
  color: #111;
}
.login-btn:active {
  background: #f3f4f6;
  border-color: #f3f4f6;
  color: #111;
}
.el-menu{
  border: none !important;
}
.login-dialog{
  ::v-deep .el-form-item__label{
    line-height: 1;
  }
}

.floating-whatsapp{
  position: fixed;
  right: 20px;
  bottom: 50vh;
  width: 56px;
  height: 56px;
  background: #25D366;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
}

.floating-whatsapp:hover{
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(37, 211, 102, 0.5);
}

.floating-whatsapp svg{
  color: #fff;
}
</style>
